import React from "react";

export default props => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M19.4262 12.0931C19.1367 12.0931 18.902 12.3277 18.902 12.6173V17.2718C18.901 18.1398 18.1977 18.8433 17.3295 18.8444H2.62099C1.75279 18.8433 1.04942 18.1398 1.0484 17.2718V3.61171C1.04942 2.74351 1.75279 2.04014 2.62099 2.03912H7.2753C7.56483 2.03912 7.79949 1.80446 7.79949 1.51492C7.79949 1.22538 7.56483 0.990723 7.2753 0.990723H2.62099C1.17412 0.992361 0.00163812 2.16484 0 3.61171V17.2718C0.00163812 18.7186 1.17412 19.8911 2.62099 19.8928H17.3295C18.7763 19.8911 19.9488 18.7186 19.9504 17.2718V12.6175C19.9504 12.3279 19.7158 12.0931 19.4262 12.0931Z" />
    <path d="M8.19675 9.33465L15.8507 1.68054L18.3191 4.14898L10.6652 11.8031L8.19675 9.33465Z" />
    <path d="M6.94788 13.052L9.67575 12.2964L7.70346 10.3241L6.94788 13.052Z" />
    <path d="M19.0016 0.383166C18.4895 -0.127722 17.6604 -0.127722 17.1483 0.383166L16.5923 0.939103L19.0608 3.40754L19.6167 2.85161C20.1278 2.33949 20.1278 1.5104 19.6167 0.99828L19.0016 0.383166Z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/Icons/svg/Edit/index.js